export const typeFacilityBooking = [
	{ id: 1, name: "Open" },
	{ id: 2, name: "Closed" },
];


// WEBPACK FOOTER //
// ./src/constant/TypeFacilityBooking.js